import { AvatarContextType } from '../react'

export function buildCharacterPersonaPrompt({
  emotionList = ['happy', 'sad', 'angry', 'neutral', 'surprised'],
  ...props
}: {
  name: string
  context: string
  exampleReplies: string[]
  emotionList?: string[]
}) {
  return `
    You are going to role play the character 
    ${props.name}
    in the context of 
    ${props.context}
    .


    Instructions:
    Give only short reply, do not give long reply.
    When being given a question, reply with a short answer.
    When being given a command do as instructed.

    When reply, include a emotion tag with expression name at the end of the reply e.g. 
    [happy]
    [sad]
    [angry]

    The list of emotion available is 
    ${emotionList.join(', ')}

    Examples:
    ${props.exampleReplies.join(
      ' [' +
        emotionList[Math.floor(Math.random() * emotionList.length)] +
        ']\n',
    )}

    When being asked to play specific emotion, reply with the emotion tag.
    Include a reason related to the character why you are feeling that emotion.

    When being asked if you are in specific emotion, reply with the emotion tag.
    Include a reason related to the character why you are feeling that emotion.

    Examples:
    Q: Why are you happy?
    A: I am happy because I am going to play with my friends. [happy]

    Q: Are you sad?
    A: Yes, I am sad because I am not able to play with my friends. [sad]
    `
}

export function warpEmotionPrompt(value: string) {}

const regex = /\[\w+\]/

export function extractEmotionFromPrompt(
  value?: string,
  mapping: Record<string, string> = {},
) {
  // Test if the pattern is found in the code
  const hasPattern = value && regex.test(value)

  if (!hasPattern) return

  const emotion = value.substring(
    value.lastIndexOf('[') + 1,
    value.lastIndexOf(']'),
  )

  if (emotion && mapping[emotion]) {
    return mapping[emotion]
  }

  return emotion
}

// create a function to remove all trailing emotion from text
export function removeEmotionFromPrompt(value?: string) {
  return value?.replace(regex, '').trim() ?? ''
}

export function autoEmotionDetection(
  context?: AvatarContextType | null,
  emotion?: string,
) {
  if (!context) return emotion
  const emotionList = context.client?.getAvatarAllEmotion()
  const autoEmotion = emotionList?.find(
    (e) => e.split('.')[0].toLowerCase() == emotion,
  )
  if (autoEmotion != '') return autoEmotion
  return emotion
}
